<!--
 * @Author: your name
 * @Date: 2021-08-24 11:09:44
 * @LastEditTime: 2023-04-21 14:40:27
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: \鲁南\src\modules\fire\components\controlDetail.vue
-->
<template>
  <div>
    <div
      class="detail-container"
      v-if="dialogVisible"
      v-loading="drawLoading"
      element-loading-text="详情加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-scrollbar class="ioc__scrollbar">
        <div class="alarm-title">设备详情</div>
        <div class="content-container">
          <div>
            <el-row v-if="controlDetailInfo.subDeviceMark">
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  主机系统类型：{{ controlDetailInfo.deviceMark | dic("SENU087") }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  主机唯一标识号：{{ controlDetailInfo.parentThirdDeviceId }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  部件名称：{{ controlDetailInfo.deviceName }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  部件类型：{{ controlDetailInfo.subDeviceMark | dic("SENU094") }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  部件地址：{{ controlDetailInfo.mac }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  部件说明：{{ controlDetailInfo.thirdDeviceDesc }}
                </div>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  设备类型：{{ controlDetailInfo.deviceMark | dic("SENU087") }}
                </div>
              </el-col>
              <!-- <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  设备编号：{{ controlDetailInfo.parentThirdDeviceId }}
                </div>
              </el-col> -->
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  设备名称：{{ controlDetailInfo.parentDeviceName }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  消防型号：{{ controlDetailInfo.deviceVersion | dic("SENU095") }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  设备厂商：{{ controlDetailInfo.factoryName }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  唯一标识号：{{ controlDetailInfo.thirdDeviceId }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  设备状态：{{ controlDetailInfo.status == 1 ? "在线" : "离线" }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  控制模式：{{
                    controlDetailInfo.controlMode == 0
                      ? "单机模式"
                      : controlDetailInfo.controlMode == 1
                      ? "多分机模式"
                      : ""
                  }}
                </div>
              </el-col>
              <el-col
                :span="24"
                v-if="
                  controlDetailInfo.deviceMark == 36 || controlDetailInfo.deviceMark == 37
                "
              >
                <div class="grid-content bg-purple-dark">
                  消防水位/m：{{ controlDetailInfo.waterLevel }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">
                  备注说明：{{ controlDetailInfo.parentThirdDeviceDesc }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-scrollbar>
      <div class="btn-group">
        <el-button @click="handleClose" type="info">关 闭</el-button>
        <el-button v-auth="'/fireControl:control'" @click="handleMain" type="primary"
          >操作消防主机</el-button
        >
      </div>
    </div>
    <div
      class="detail-container"
      v-if="videoDialog"
      v-loading="drawLoading"
      element-loading-text="视频配置加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-scrollbar class="ioc__scrollbar">
        <div class="alarm-title">关联视频</div>
        <div class="content-container">
          <div>
            <el-row>
              <el-col :span="24" v-if="!videoConfigInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">
                  主机编号：{{ videoConfigInfo.parentThirdDeviceId }}
                </div>
              </el-col>
              <el-col :span="24" v-if="!videoConfigInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">
                  主机名称：{{ videoConfigInfo.parentDeviceName }}
                </div>
              </el-col>
              <el-col :span="24" v-if="videoConfigInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">
                  部件名称：{{ videoConfigInfo.deviceName }}
                </div>
              </el-col>
              <el-col :span="24" v-if="videoConfigInfo.subDeviceMark">
                <div class="grid-content bg-purple-dark">
                  部件类型：{{ videoConfigInfo.subDeviceMark | dic("SENU094") }}
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple-dark">关联摄像机方式：</div>
                <el-select
                  v-model="videoConfigInfo.relationCameraType"
                  style="width: 100%"
                  placeholder="请选择关联方式"
                >
                  <el-option
                    v-for="item in videoOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="24" v-if="videoConfigInfo.relationCameraType == '3'">
                <el-button @click="selectCamera()" type="info">添加摄像机</el-button>
                <div
                  class="group map-blur-panel__content p10"
                  style="max-height: 400px; min-height: 100px; overflow: auto"
                >
                  <el-scrollbar ref="scrollBar" class="scroll-bar">
                    <ul class="worker-content">
                      <li
                        v-for="(item, ind) in tableData"
                        :key="ind"
                        class="flex-between"
                        style="padding-right: 10px"
                      >
                        <div>
                          <span
                            class="f12 icon iconfont-lunan icon-lunan-shexiangjizuguanli"
                          ></span>
                          <span class="camera-name ml5">{{ item.cameraName }}</span>
                          <!-- <span class="camera-name ml5">【摄像机】</span> -->
                        </div>
                        <div class="point-icon">
                          <el-button
                            type="text"
                            title="预览"
                            icon="el-icon-video-camera"
                            @click="preview(item)"
                          ></el-button>
                          <el-button
                            type="text"
                            title="删除"
                            icon="el-icon-delete"
                            @click="deleteVideo(ind)"
                          ></el-button>
                        </div>
                      </li>
                    </ul>
                  </el-scrollbar>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!-- 视频配置 -->
      </el-scrollbar>
      <span class="btn-group">
        <el-button type="info" @click="handleVideoClose"> 取消 </el-button>
        <el-button type="primary" @click="updateVideoForm"> 确认 </el-button>
      </span>
      <!-- 摄像机树组件 -->
      <el-dialog
        title="设备树"
        :visible.sync="cameraVisible"
        append-to-body
        v-dialogDrag
        width="30%"
        class=""
      >
        <el-scrollbar class="device-tree-dialog">
          <device-group-tree
            ref="deviceTree"
            v-if="cameraVisible"
            @cameraData="getCameraData"
            :multiCheck="true"
          >
          </device-group-tree>
        </el-scrollbar>

        <div slot="footer" class="dialog-footer">
          <el-button @click="cancleCamera">取 消</el-button>
          <el-button type="primary" @click="confirmCamera">确 定</el-button>
        </div>
      </el-dialog>
      <video-config ref="videoConfig"></video-config>
      <!-- button 操作 -->
      <!-- <div
        class="ioc-alarm__drawer__btns map-blur-panel__title btn-group"
      >
        <el-button @click="handleConfirm" type="primary"> 确 认 </el-button>
      </div> -->
    </div>
  </div>
</template>
<script>
import { Dic } from "$utils";
import { api } from "../api";
import videoConfig from "@src/modules/cameraList/components/videoConfig";
import deviceGroupTree from "@src/modules/cameraList/components/device-group-tree";
export default {
  components: {
    videoConfig,
    deviceGroupTree,
  },
  props: {
    controlDetailInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isExpand: false,
      dialogVisible: false,
      videoDialog: false,
      drawLoading: true,
      videoConfigInfo: {},
      cameraVisible: false,
      cameraList: [],
      videoOptions: [
        {
          value: 1,
          label: "关联主机视频",
        },
        {
          value: 2,
          label: "关联楼栋楼层视频",
        },
        {
          value: 3,
          label: "自定义配置",
        },
      ],
      parentVideoOptions: [
        {
          value: 1,
          label: "自定义配置",
        },
      ],
      cameraIdList: [],
      tableData: [],
      newCameraData: [],
    };
  },
  mounted() {},
  methods: {
    // 确认按钮
    handleConfirm() {
      this.dialogVisible = false;
      // 修改位置回调
      this.$emit("handleConfirm");
    },
    // 操作主机按钮
    handleMain() {
      let newMsg = window.location.href.split("#")[0];
      window.open(newMsg + "#/fireManage?id=" + this.controlDetailInfo.deviceId);
      // this.$router.push({
      //   path: "/fireManage",
      //   name: "fireManage",
      //   query: {
      //     id: this.controlDetailInfo.deviceId,
      //   },
      // });
      // this.$emit("handleMain");
    },
    confirmCamera() {
      if (this.newCameraData.length > 9) {
        this.$message.warning("最多选择9路摄像机视频");
        return;
      }
      this.tableData = [];
      this.cameraIdList = [];
      if (this.newCameraData.length) {
        this.tableData = this.newCameraData.map((item) => {
          this.cameraIdList.push(item.thirdCameraId);
          return {
            thirdCameraId: item.thirdCameraId,
            cameraName: item.name,
          };
        });
      }
      this.cameraVisible = false;
    },
    getCameraData(data) {
      this.newCameraData = [].concat(data);
    },
    cancleCamera() {
      this.cameraVisible = false;
    },
    deleteVideo(ind) {
      this.tableData.splice(ind, 1);
      this.cameraIdList.splice(ind, 1);
    },
    showDetailDialog() {
      this.dialogVisible = true;
      this.videoDialog = false;
      this.drawLoading = false;
    },
    //获取运行数据列表
    getList(deviceId) {
      const params = {
        deviceId: deviceId,
        cameraConfigFlag: 0,
      };
      this.$fetch(api.video.queryFirefightingCameraList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj ? [...response.returnObj] : [];
        this.cameraIdList = this.tableData.map((item) => {
          return item.thirdCameraId;
        });
      });
    },
    showVideoDialog(videoConfigInfo) {
      this.videoDialog = true;
      this.dialogVisible = false;
      this.drawLoading = false;
      this.videoConfigInfo = videoConfigInfo;
      this.$nextTick(() => {
        this.getList(this.videoConfigInfo.deviceId);
      });
    },
    // 打开视频播放组件
    preview(cameraInfo) {
      this.$app.AppInstance.handleMiniPlay({
        playType: "live", // 'live',
        playTitle: cameraInfo.cameraName, //摄像机名称
        playId: cameraInfo.thirdCameraId, //摄像机id
      });
    },
    handleVideoClose() {
      this.videoDialog = false;
      // this.$emit("handleVideoClose");
    },
    handleClose() {
      this.dialogVisible = false;
      // this.$emit("handleClose");
    },
    updateVideoForm() {
      const params = {
        cameraConfigFlag: "0",
        deviceId: this.videoConfigInfo.deviceId,
        relationCameraType: this.videoConfigInfo.relationCameraType,
      };
      if (this.videoConfigInfo.relationCameraType == 3) {
        params.cameraList = this.cameraIdList.map((el) => {
          return {
            thirdCameraId: el,
          };
        });
      }
      this.$fetch(api.video.updateFirefightingCamera, params).then((res) => {
        if (res.success) {
          this.$message.success("修改成功");
          this.$emit("handleVideo");
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },

    //选择摄像机
    selectCamera() {
      this.cameraVisible = true;
      // console.log(this.cameraIdList);
      this.$nextTick(() => {
        this.$refs.deviceTree.$refs.tree.setCheckedKeys(this.cameraIdList);
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.detail-container {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 10;
  width: 350px;
  height: calc(100% - 0px);
  background-color: rgba(11, 18, 35, 0.35);
  backdrop-filter: blur(5px);
  // @include set_theme_color(background-color, blur-color);
  display: flex;
  flex-direction: column;
  transition: right 0.2s;
  .ioc__scrollbar {
    height: calc(100% - 62px) !important;
    .alarm-title {
      // color: #b3cbf1;
      margin: 16px 16px 16px 25px;
      font-size: 16px;
      border-left: 4px solid #407aee;
      position: relative;
      line-height: 16px;
      text-align: left;
      padding-left: 10px;
      font-size: 16px;
    }
    .content-container {
      padding: 15px 12px;
      margin: 12px;
      line-height: 40px;
      opacity: 1;
      @include set_theme_color(background-color, map-panel-content);
    }
  }
  .ioc-alarm__drawer__btns {
    text-align: center;
    padding: 5px 0;
  }
  .btn-group {
    margin-top: 16px;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .el-table__row {
    cursor: pointer;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
  .point-icon {
    .el-button {
      font-size: 16px !important;
      color: #fff !important;
    }
  }
}

.icon-transform {
  transform: rotate(180deg);
}
</style>
